/// <reference path="Main.js" />
/* global scroll_to_element */

/** @typedef {import('select2').Options<import('select2').DataFormat | import('select2').GroupedDataFormat, any>} Select2Options */

if (typeof window.jjk === 'undefined') {
	window.jjk = {};
}

/**
 * Erstellt ein Option-DOM-Element mit dem übergebenem Wert und Text
 *
 * @param {string} wert Wert des Element
 * @param {string} text Text des Elements
 * @returns {HTMLOptionElement} DOM Elelement
 */
jjk.createSelectOption = function (wert, text) {
	'use strict';
	const option = document.createElement('option');
	option.text = text;
	option.value = wert;
	return option;
};

/**
 * Initialisiert eine Select2, wenn noch nicht geschehen
 *
 * @param {JQuery<HTMLElement> | string} selector
 * @param {Select2Options} [opts]
 * @returns {void}
 */
jjk.initSelect2 = function (selector, opts = {}) {
	if (typeof $.fn.select2 == 'undefined') {
		return;
	}
	if (typeof selector === 'string' && !selector.startsWith('#')) {
		selector = `#${selector}`;
	}
	$(selector).each(
		/**
		 * @param {number} idx
		 * @param {HTMLElement} elem
		 */
		(idx, elem) => {
			if (!$(elem).hasClass('select2-hidden-accessible')) {
				if (!elem.id) {
					// eslint-disable-next-line no-console
					console.error('Label für Select2 nicht gefunden', elem);
					if (window.location.origin === 'http://localhost:5075') {
						import('../ts/classes/toast.js').then(({ default: JjkToast }) => {
							new JjkToast({
								toastClass: 'text-bg-danger',
								closeButtonClass: 'btn-close-white',
								body: `Keine ID für Select2: ${elem.id || elem.placeholder || elem.name}`,
								delay: -1,
							}).show();
						});
					}
					return;
				}
				if (window.location.origin === 'http://localhost:5075' && document.querySelectorAll(`[id=${elem.id}]`).length > 1) {
					// eslint-disable-next-line no-console
					console.error('Mehrere Elemente mit dem selben ID', elem);
					import('../ts/classes/toast.js').then(({ default: JjkToast }) => {
						new JjkToast({ toastClass: 'text-bg-danger', closeButtonClass: 'btn-close-white', body: `Mehrere Elemente mit dem selben ID: ${elem.id}`, delay: -1 }).show();
					});
					return;
				}
				if (!elem.multiple) {
					if (!elem.classList.contains('form-select')) {
						elem.classList.add('form-select');
					}
				}
				const label = document.querySelector(`label[for="${elem.id}"]`);
				$(elem).select2(opts);
				window.jjk.select2Observers = window.jjk.select2Observers || [];
				if (!window.jjk.select2Observers[elem.id]) {
					window.jjk.select2Observers[elem.id] = new MutationObserver(mutations => {
						mutations
							.filter(
								mutation =>
									mutation.type === 'attributes' &&
									mutation.attributeName?.startsWith('aria-') &&
									mutation.attributeName !== 'aria-labelledby' &&
									mutation.attributeName !== 'aria-controls'
							)
							.forEach(mutation => {
								elem.nextElementSibling?.querySelector('[role="combobox"]')?.setAttribute(mutation.attributeName, elem.getAttribute(mutation.attributeName));
							});
					});
				}
				window.jjk.select2Observers[elem.id].observe(elem, { attributes: true });
				if (elem.classList.contains('input-validation-error')) {
					elem.ariaInvalid = 'true';
				}
				if (label) {
					if (!label.id) {
						label.id = `${elem.id}-label-select2`;
					}
					elem.nextElementSibling?.querySelector('[role="combobox"]')?.setAttribute('aria-labelledby', label.id);
				} else {
					if (window.location.origin === 'http://localhost:5075') {
						// eslint-disable-next-line no-console
						console.error('Label für Select2 nicht gefunden', elem);
						import('../ts/classes/toast.js').then(({ default: JjkToast }) => {
							new JjkToast({ toastClass: 'text-bg-danger', closeButtonClass: 'btn-close-white', body: `Kein Label für Select2: ${elem.id}`, delay: -1 }).show();
						});
					}
				}
			}
		}
	);
};

/**
 * Setzt select2-Elemente durch Zerstörung und Neu-Initialisiert zurück
 *
 * @param {JQuery<HTMLElement>|string} selector
 * @param {Select2Options} [opts]
 * @returns {void}
 */
jjk.refreshSelect2 = function (selector, opts = {}) {
	if (typeof $.fn.select2 == 'undefined') {
		return;
	}
	if (typeof selector === 'string' && !selector.startsWith('#')) {
		selector = `#${selector}`;
	}
	$(selector).each((idx, elem) => {
		if ($(elem).hasClass('select2-hidden-accessible')) {
			window.jjk.select2Observers?.[elem.id]?.disconnect();
			$(elem).select2('destroy');
		}
		jjk.initSelect2(elem, opts);
	});
};

/**
 * Setz eine Meldung unter ein Formularfeld im angemessenen Design
 *
 * @param {object} selector CSS-Selector oder jQuery-Objekt oder DOM-Element
 * @param {string} msg Fehlermeldung
 * @returns {void}
 */
jjk.setInvalidFeedback = function (selector, msg) {
	'use strict';
	if (jjk.design.IsModern) {
		let $errorContainer = $(selector).parent().children('.invalid-feedback');
		if (msg) {
			$errorContainer.text(msg).show();
		} else {
			$errorContainer.text(msg).hide();
		}
	} else {
		let $errorContainer = $(selector).parent().children('.field-validation-error');
		if (msg) {
			if (!$errorContainer.length) {
				$errorContainer = $('<span class="field-validation-error" />').appendTo($(selector).parent());
			}
			$errorContainer.text(msg).show();
		} else {
			$errorContainer.remove();
		}
	}
};

/**
 * Leert eine Select-Liste. Wenn abIndex angegeben, bleiben die Elemente unterhalb dieses Indizes bestehen
 *
 * @param {object} select Select-DOM-Element (bspw. per getElementById beschafft)
 * @param {int} abIndex wenn angegeben, erst ab diesem Index löschen
 * @returns {void}
 */
jjk.clearSelect = function (select, abIndex) {
	'use strict';
	if (typeof abIndex === 'undefined' || abIndex === null) {
		abIndex = 0;
	}
	if (select && select.tagName.toLowerCase() === 'select') {
		while (select.length > abIndex) {
			select.options.remove(abIndex);
		}
	}
};

/**
 * Liefert den nötigen Prefix für KundendatenViewModel-Felder
 *
 * @param {boolean} forId Gibt an, ob der Präfix für die Id oder den Namen generiert werden soll
 *
 * @returns {string} Der zu verwendende KundendatenViewModel-Präfix
 */
jjk.kundendatenViewModelPrefix = function (forId) {
	'use strict';
	if (typeof forId === 'undefined') {
		forId = true;
	}
	// Wenn es mindestens ein Input-Element mit der ID KundendatenViewModel_*  oder mit ID  KundendatenIndexViewModel_* gibt, dann muss dieser Prefix verwendet werden, sonst nicht
	if ($('input[id^="KundendatenViewModel_"]').length) {
		return `KundendatenViewModel${forId ? '_' : '.'}`;
	} else if ($('input[id^="KundendatenIndexViewModel_"]').length) {
		return `KundendatenIndexViewModel${forId ? '_' : '.'}`;
	} else {
		return '';
	}
};

/**
 * Registriert den Handler, der die Abo-Preisdarstellung bei einem Wechsel der Kundenart neu lädt.
 *
 * Kundendaten.js löst beim Initialisieren der Seite selbst ein change aus. Ohne den Vergleich mit der
 * zuletzt bekannten Kundenart würde die Darstellung deshalb bereits beim Seitenaufbau ersetzt und eine
 * über den Template-Editor gepflegte Darstellung damit sofort wieder überschrieben.
 *
 * @param {string} getPreisInfoUrl URL, die die neue Preisdarstellung liefert
 */
jjk.bindeAboKundenartWechsel = function (getPreisInfoUrl) {
	'use strict';
	const kundenart = $('#Kundenart');
	let letzteKundenart = kundenart.val();
	kundenart.on('change', function (e) {
		if (kundenart.val() === letzteKundenart) {
			return;
		}
		letzteKundenart = kundenart.val();
		$.post(getPreisInfoUrl, $(e.currentTarget).closest('form').serialize()).then(function (data) {
			// Ist die Seite über ein eigenes Template gestaltet, liefert der Server das komplette Template
			// zurück und nicht nur den Preisblock.
			$(jjk.elementVorhanden('#abo-darstellung') ? '#abo-darstellung' : '#abo-preis').html(data);
		});
	});
};

/**
 * Prüft ob ein HTML-Element existiert
 *
 * @param {object} selector jQuery-Objekt, CSS-Selector oder ID der Felds
 * @returns {boolean} HTML-Element existiert
 */
jjk.elementVorhanden = function (selector) {
	'use strict';
	if (typeof selector === 'string' && !selector.includes('#') && !selector.includes('.') && !selector.includes(' ')) {
		selector = `#${selector}`;
	}
	return $(selector).length > 0;
};

/**
 * Liefert den Array-Index des ViewModel-Felds
 * @param {any} $obj jQuery Objekt
 * @param {number} [index] Für verschachtelte ViewModel-Arrays: die wievielte [] im Namen ausgewertet werden soll
 * @returns {string} -
 */
jjk.getMvcInputNameCounter = function ($obj, index = -1) {
	const matches = $obj.attr('name').allMatches(/\[(\d*)\]/i);
	return matches[index > -1 ? index : matches.length - 1][1];
};

/**
 * Liefert den neuen Namen des ViewModel-Felds mit dem neuen Index
 * @param {string} name Der aktuelle Name des Felds
 * @param {number} newCounter Der neue Array-Index
 * @param {number} [index] Für verschachtelte ViewModel-Arrays: die wievielte [] im Namen ausgewertet werden soll
 * @returns {string} -
 */
jjk.replaceArrayCounterInMvcName = function (name, newCounter, index = -1) {
	const matches = name.allMatches(/\[(\d*)\]/i);
	const match = matches[index > -1 ? index : matches.length - 1];
	const index2 = match.index + match[1].length + 1;
	return name.substr(0, match.index + 1) + newCounter + name.substr(index2, name.length + index2);
};

/**
 * Erstellt ein Array mit Objekten mit je 2 Properties: dem Namen und dem Wert der Properties des übergebenen Objekts
 * @param {any} objekt Objekt
 * @param {any} [name] Namen-Property des zu erstellenen "Unterobjekts" des Arrays
 * @param {any} [value] Value-Property des zu erstellenen "Unterobjekts" des Arrays
 * @param {any} [nurGesetzte] Wenn true, werden nur gefüllte (true-ish) Properties verarbeitet
 * @returns {object[]} Props als Array
 */
jjk.propsToArray = function (objekt, name = 'name', value = 'wert', nurGesetzte = true) {
	const arr = [];
	for (const prop in objekt) {
		if (!Object.prototype.hasOwnProperty.call(objekt, prop)) {
			continue;
		} // siehe: https://eslint.org/docs/rules/guard-for-in
		if (!nurGesetzte || objekt[prop]) {
			arr.push({ [name]: prop, [value]: objekt[prop] });
		}
	}
	return arr;
};

jjk.erstesFehlerhaftesFeld = function () {
	'use strict';
	return $('input, textarea, select')
		.filter('.error, .is-invalid, .input-validation-error')
		.filter(':visible')
		.toArray()
		.sort((a, b) => $(a).offset().top - $(b).offset().top);
};

jjk.scrolleZuErstemFehlerhaftenFeld = function () {
	'use strict';
	const fehlerhafteFelderSortiert = jjk.erstesFehlerhaftesFeld();
	if (fehlerhafteFelderSortiert.length) {
		scroll_to_element($(fehlerhafteFelderSortiert[0]).closest('div[data-form-group-for-field], td'), 100, false, true);
		return true;
	}
	return false;
};

jjk.fokusiereErstesFehlerhaftesFeld = function () {
	'use strict';
	const fehlerhafteFelderSortiert = jjk.erstesFehlerhaftesFeld();
	if (fehlerhafteFelderSortiert.length) {
		$(fehlerhafteFelderSortiert[0]).trigger('focus');
		return true;
	}
	return false;
};

jjk.isScrimVisible = function () {
	return (
		Array.from(document.querySelectorAll('.wb_scrim')).filter(
			elem => !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length) && window.getComputedStyle(elem).visibility !== 'hidden'
		).length > 0
	);
};

/**
 * @returns {Promise<boolean>} true, wenn auf einen sichtbaren Scrim gewartet wurde, sonst false
 */
jjk.waitForScrim = function () {
	return new Promise(resolve => {
		if (!jjk.isScrimVisible()) {
			resolve(false);
			return;
		}
		const interval = window.setInterval(() => {
			if (jjk.isScrimVisible()) {
				window.clearInterval(interval);
				resolve(true);
			}
		}, 100);
	});
};

jjk.wichtigsteAlertsVorlesen = function () {
	'use strict';
	const classRanking = {
		'validation-summary-errors': 4,
		'validation-summary-error': 4,
		'alert-danger': 4,
		'alert-warning': 3,
		'alert-info': 2,
		'alert-success': 1,
	};
	const getHighestClassRank =
		/**
		 * @param {DOMTokenList} classList
		 * @returns {number}
		 */
		classList =>
			classList.length === 0
				? 0
				: Array.from(classList)
						.map(className => classRanking[className] || 0)
						.sort()
						.reverse()[0];
	/** @type {NodeListOf<HTMLElement>} */
	const alertElems = document.querySelectorAll('[role="alert"]:not([data-beim-laden-nicht-vorlesen]), .validation-summary-errors[data-jjk-role="alert"]');
	const alerts = Array.from(alertElems)
		.filter(elem => !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length) && window.getComputedStyle(elem).visibility !== 'hidden')
		.map(a => ({ elem: a, rank: getHighestClassRank(a.classList) }));
	const maxRank = Math.max(...[0, ...alerts.map(a => a.rank)]);
	if (alerts.length && maxRank > 0) {
		for (const alert of alerts.filter(a => a.rank === maxRank)) {
			if (alert.elem.classList.contains('validation-summary-errors') && alert.elem.querySelectorAll('li').length > 0) {
				alert.elem.querySelectorAll('li').forEach(li => {
					const html = li.innerHTML;
					window.setTimeout(() => {
						li.innerHTML = '';
						li.role = 'alert';
						li.innerHTML = html;
					}, 300);
				});
			} else {
				const html = alert.elem.innerHTML;
				window.setTimeout(() => {
					alert.elem.innerHTML = '';
					alert.elem.innerHTML = html;
				}, 300); // muss (mind.) 300 sein? (siehe u.A. https://cerovac.com/a11y/2023/08/status-messages-on-page-load-how-to-notify-screen-reader-users-about-important-messages-when-the-page-loads/)
			}
		}
		return true;
	}
	return false;
};

/**
 * Prüft, ob ein IMG aktuell mindestens so breit dargestellt wird, wie die eigentliche Datei breit ist
 * @param {HtmlElement} img HTML Element des Bilds
 * @returns {boolean} Bild wird mindestens mit der "echten" Breite dargestellt
 */
jjk.bildHatMindestensOringalBreite = function (img) {
	'use strict';
	return img && img.clientWidth >= img.naturalWidth;
};

/**
 * @param {HTMLElement|function} container container, der gescrollt werden kann und in dem die Elemente sind. bei "normal" platzierten Elementen reicht document. Kann auch eine function sein, für den Fall, dass das Element zum Zeitpunkt des Aufrufs von lazy noch nicht existiert
 * @param {string} selector selector der Elemente innerhab des containers. Wird an querySelectorAll übergeben. bspw. '.lazy' oder '[data-src]'
 * @param {boolean} [sofortAusfuehren] nicht auf DOMContentLoaded warten
 * @returns {void}
 */
jjk.lazy = function (container, selector, sofortAusfuehren = false) {
	function createObserver() {
		const resolvedContainer = typeof container === 'function' ? container() : container;
		if (!resolvedContainer) {
			return;
		}
		const logoObserver = new IntersectionObserver(
			(entries, observer) => {
				entries
					.filter(e => e.intersectionRatio > 0)
					.forEach(entry => {
						entry.target.src = entry.target.dataset.src;
						observer.unobserve(entry.target);
					});
			},
			{ threshold: 0.1, root: resolvedContainer }
		);
		resolvedContainer.querySelectorAll(selector).forEach(elem => {
			logoObserver.observe(elem);
		});
	}

	if (sofortAusfuehren || document.readyState !== 'loading') {
		createObserver();
	} else {
		document.addEventListener('DOMContentLoaded', createObserver);
	}
};

/**
 * @param {string} selector
 * @returns {Record<string, unknown>}
 */
jjk.serializeToObject = function serializeToObject(selector) {
	const data = {};
	$(selector)
		.find('input[type="hidden"], :input:not(:hidden):not(:button):not(button)')
		.each((idx, elem) => {
			const prop = elem.name || elem.id;
			if (prop) {
				let val = $(elem).val();
				if ($(elem).is(':checkbox') || $(elem).is(':radio')) {
					if (!$(elem).prop('checked')) {
						val = null;
					}
					// Simple Checkboxen / Radiobuttons
					if (['true', 'false', 'True', 'False'].includes(val)) {
						val = $(elem).prop('checked');
					}
					// Checkboxen mit echten Values
					else if ($(elem).is(':checkbox') && $(elem).prop('checked')) {
						if (data[prop]) {
							if (Array.isArray(data[prop])) {
								val = [...data[prop], val];
							} else {
								val = [data[prop], val];
							}
						} else {
							val = [val];
						}
					}
				} else {
					if (val === 'true' || val === 'True') {
						val = true;
					}
					if (val === 'false' || val === 'False') {
						val = false;
					}
					if (!isNaN(parseFloat(val)) && parseFloat(val).toString() === val) {
						val = parseFloat(val);
					}
				}
				if (val !== null) {
					data[prop] = val;
				}
			}
		});
	return data;
};

/**
 * Führt eine Funktion aus, sobald der Seiteninhalt komplett geladen ist, bzw. sofort, falls dies bereits der Fall ist
 * @param {function(): void} fn Funktion, die ausgeführt werden soll
 * @returns {void}
 */
jjk.onLoad = function (fn) {
	if (document.readyState === 'complete') {
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', () => {
			fn();
		});
	}
};

jjk.microsoftJSONSerializationFix = function (key, value) {
	if (typeof value === 'string') {
		const isDate = /Date\(([-+]?\d+[-+]?\d+)\)/.exec(value);
		if (isDate) {
			return new Date(+isDate[1]);
		}
	}
	return value;
};

/**
 * Sendet ein Formular ab und verarbeitet das Ergebnis
 *
 * Das Ergebnis ist entweder eine Umleitung, der ModelState mit den Validierungsfehlern oder ein Server-Fehler.
 * @param {HTMLFormElement | string} form Form, die gepostet werden soll. Entweder die Form selbst, oder der Selektor
 * @returns {Promise<string>} URL, zu der weiter navigiert werden soll, oder null bei Problemen
 */
jjk.ajaxPost = async function (form) {
	'use strict';
	if (typeof form == 'string') {
		form = document.querySelector(form);
	}
	if (!(form && form instanceof HTMLFormElement)) {
		throw new Error(`${form} ist kein Formular!`);
	}
	if (!window.scrim) {
		window.scrim = new JJK.UI.ScrimmedMessage(`<img src="${window.webAdBaseUrl}Content/images/ajax_loader.gif" />`, Strings.DatenUebertragen, `scrim_${form.id}`);
		window.scrim.show();
	}
	const options = {
		method: 'POST',
		referrerPolicy: 'no-referrer',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
			'X-Requested-With': 'XMLHttpRequest',
		},
		body: $(form).serialize(),
	};
	form.classList.remove('was-validated');
	const result = await fetch(form.action, options);
	const isJson = result && result.headers && result.headers.get('Content-Type') && result.headers.get('Content-Type').split(';')[0] === 'application/json';
	const data = isJson ? await result.text().then(jsonText => JSON.parse(jsonText, jjk.microsoftJSONSerializationFix)) : await result.text();
	window.scrim.hide();
	window.submit_form_called = false;
	if (result.ok) {
		if (typeof data == 'object' && data.redirectUrl) {
			return data.redirectUrl;
		} else {
			return null;
		}
	} else {
		if (result.status >= 400 && result.status < 500) {
			if (typeof data == 'object' && Object.keys(data).length) {
				form.querySelectorAll('.jjk-ajax-post-fehler').forEach(elem => elem.remove()); // bei erneutem fehlerhaften AJAX-Post, alte Fehler von Feldern entfernen
				form.querySelectorAll('.is-invalid').forEach(elem => elem.classList.remove('is-invalid'));
				const fehlerListe = form.querySelector('.jjk-ajax-post-fehler-liste') || document.createElement('div');
				fehlerListe.innerHTML = ''; // bei erneutem fehlerhaften AJAX-Post, alte Fehler aus Liste entfernen
				fehlerListe.classList.add('jjk-ajax-post-fehler-liste', 'alert', 'alert-danger', 'fs-6');
				form.prepend(fehlerListe);
				let fehlerListeGefuellt = false;
				for (const key of Object.keys(data)) {
					const feld = form.querySelector(`[name="${key}"]`);
					const fehlerDiv = document.createElement('div');
					fehlerDiv.innerText = data[key];
					fehlerDiv.classList.add('field-validation-error', 'jjk-ajax-post-fehler');
					if (feld) {
						// Wenn es ein passendes Feld gibt:
						// - Feld und Label (wenn vorhanden) invalid (rot) machen
						// - Fehlermeldung in den Parent des Felds hinzufügen (sollte immer eine "Wrapper"-DIV oder so sein)
						// - Bei Änderung des Felds die Markierung entfernen
						feld.classList.add('is-invalid');
						const label = form.querySelector(`label[for="${feld.id}"]`);
						if (label) {
							label.classList.add('is-invalid');
						}
						feld.addEventListener(
							'input',
							evt => {
								if (label) {
									label.classList.remove('is-invalid');
								}
								evt.target.classList.remove('is-invalid');
								fehlerDiv.remove();
							},
							{ once: true }
						);
						let parent = feld.parentElement;
						if (parent.classList.contains('input-group')) {
							parent = parent.parentElement;
						}
						parent.append(fehlerDiv);
					} else {
						// Wenn keine passendes Feld gefunden:
						// - Fehler in Liste am Anfang der Form "sammeln", wenn nicht bereits auf der Seite (bspw. durch Server-Validierung beim Aufruf der Seite) der gleiche Fehler steht
						if (!Array.from(form.querySelectorAll('.field-validation-error')).some(elem => elem.innerText === fehlerDiv.innerText)) {
							fehlerListeGefuellt = true;
							fehlerListe.append(fehlerDiv);
						}
					}
				}
				if (!fehlerListeGefuellt) {
					fehlerListe.remove();
				}
				form.classList.add('was-validated');
			} else if (typeof data == 'string') {
				const responseHtmlBodyContent = data.match(/<body[^>]*>([^]*)<\/body/m)[1];
				window.jjk.bootstrapModalHelper.message(responseHtmlBodyContent, 'modal-xl', 'Serverfehler');
			}
		}
		if (result.status >= 500 && result.status < 600) {
			const responseHtmlBodyContent = data.match(/<body[^>]*>([^]*)<\/body/m)[1];
			window.jjk.bootstrapModalHelper.message(responseHtmlBodyContent, 'modal-xl', 'Serverfehler');
		}
		return null;
	}
};

/**
 * @template T
 * @param {function(): void|T} func
 * @returns {void|T}
 */
jjk.cursorPositionBehalten = func => {
	const { left, top } = document.getSelection().getRangeAt(0).getBoundingClientRect();
	const result = func();
	let node;
	/** @type {number} */
	let offset;
	if ('caretPositionFromPoint' in document && typeof document.caretPositionFromPoint == 'function') {
		const range = document.caretPositionFromPoint(left, top);
		node = range.offsetNode;
		offset = range.offset;
	} else if ('caretRangeFromPoint' in document && typeof document.caretRangeFromPoint == 'function') {
		const range = document.caretRangeFromPoint(left, top);
		node = range.startContainer;
		offset = range.startOffset;
	}
	if (node) {
		// document.getSelection().removeAllRanges();
		document.getSelection().collapse(node, offset);
	}
	return result;
};

/**
 * @param {(HTMLElement|string)[]} elemente
 * @param {string} text
 * @returns {function(): void}
 */
jjk.blockWhileFetching = (elemente, text = null) => {
	/** @type {Map<HTMLElement, {position: string, loadingDiv: HTMLDivElement}} */
	const elementStore = new Map();
	elemente.forEach(element => {
		if (typeof element === 'string') {
			element = document.querySelector(element);
		}
		if (!(element instanceof HTMLElement)) {
			return;
		}
		const position = element.style.position;
		element.style.position = 'relative';
		const loadingDiv = document.createElement('div');
		Object.assign(loadingDiv.style, { position: 'absolute', zIndex: 999999, top: '0', left: '0', bottom: '0', right: '0' });
		Object.assign(loadingDiv.style, { display: 'grid', placeContent: 'center', background: 'rgb(255 255 255 / 70%)', cursor: 'not-allowed' });

		const animation = document.createElement('i');
		animation.classList.add('fas', 'fa-circle-notch', 'fa-spin');
		animation.style.fontSize = 'calc(min(5rem, 50vmin))';

		if (text) {
			const wrapperDiv = document.createElement('div');
			Object.assign(wrapperDiv.style, { display: 'flex', gap: '1rem', flexDirection: 'column', alignItems: 'center' });
			const textDiv = document.createElement('div');
			Object.assign(textDiv.style, { fontSize: '1rem', lineHeight: '1', padding: '0.5rem', background: 'white' });
			textDiv.innerText = text;
			wrapperDiv.append(animation);
			wrapperDiv.append(textDiv);
			loadingDiv.append(wrapperDiv);
		} else {
			loadingDiv.append(animation);
		}
		element.append(loadingDiv);
		elementStore.set(element, { position, loadingDiv });
	});
	return () => {
		for (const [elem, data] of elementStore.entries()) {
			elem.style.position = data.position;
			data.loadingDiv.remove();
		}
		elementStore.clear();
	};
};

/**
 * @param {number} ms Millisekunden
 * @returns {Promise<void>}
 */
jjk.sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

/**
 * @param {string} name
 * @param {function(): void} func
 */
jjk.waitForWindowProp = async (name, func) => {
	// eslint-disable-next-line no-unmodified-loop-condition
	while (!(name in window)) {
		await jjk.sleep(100);
	}
	func();
};

/**
 * @param {string} nachricht
 */
jjk.screenReaderBenachrichtigung = nachricht => {
	const div = document.createElement('div');
	div.classList.add('visually-hidden');
	div.role = 'alert';
	div.innerText = nachricht;
	document.body.append(div);
	setTimeout(() => div.remove(), 200);
};

// jQuery UI hat (warum auch immer) so gut wie keine Lokalisierungsmöglichkeit (nur Datepicker)
// Daher den entsprechenden Code gesucht und die undokumentierte Option hier gefunden: https://github.com/jquery/jquery-ui/blob/1.14.1/ui/widgets/autocomplete.js#L611
/** @type {{ noResults: string, results: (amount: number) => string }} */
jjk.autocompleteMessages = {
	noResults: 'Nichts gefunden.',
	results: anzahl => `${anzahl > 1 ? `${anzahl} Ergebnisse` : 'Ein Ergebnis'} verfügbar, verwenden Sie Pfeil hoch und runter um durch die Auswahl zu navigieren.`,
};

/**
 * @param {HTMLElement} bereich
 * @param {Promise<void>} zuLaden
 */
jjk.ladekreis = async (bereich, zuLaden) => {
	const loadingDiv = document.createElement('div');
	loadingDiv.classList.add('loading-div');
	loadingDiv.style.zIndex = '9999';
	const iconWrapper = document.createElement('div');
	iconWrapper.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
	loadingDiv.append(iconWrapper);
	bereich.append(loadingDiv);
	try {
		await zuLaden();
	} finally {
		loadingDiv.remove();
	}
};

/**
 * @param {number} minuten
 * @returns {string} Zeit
 */
jjk.minutenZuZeit = minuten => {
	const stunden = Math.floor(minuten / 60);
	const minutenRest = minuten % 60;
	return `${stunden}:${minutenRest < 10 ? '0' : ''}${minutenRest}`;
};
